export default {
  tableContainer: {
    fontFamily: '"Urbanist", sans-serif !important',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '8px',
      marginTop: '23px',
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      zIndex: 10,
      background:'rgb(129, 134, 169)',
      borderRadius: '10px',
    },
  },
  theadEmbedTooltip: {
    color: '#fff',
    fontSize: '12px',
    marginTop: '27px',
    marginBottom: '0',
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    padding: '1px 5px 2px 5px',
    backgroundColor: 'rgba(78, 76, 76, 0.7)',
  },
  sortersBtn: {
    flexShrink: '0',
    color: '#4E4C4C',
    display: 'flex',
    fontSize: '12px',
    padding: '2px 10px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  sortersBtnSelected: {
    borderRadius: '4px',
    background: '#ffff',
  },
  addNewSorter: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
  },
  addSorterSortBy: {
    width: '130px',
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
  },
  addSorterSelect: {
    '& .autocomplete-placeholder': {
      color: '#878787',
      fontSize: '12px',
      fontStyle: 'italic',
    },
  },
  sortBySelectLabel: {
    display: 'flex',
    flexShrink: '0',
    color: '#4E4C4C',
    marginRight: '10px',
  },
  tableMenuRow: {
    display: 'flex',
    color: '#4c4c4c',
    fontSize: '12px',
    padding: '4px 10px',
    '&:hover': {
      cursor: 'pointer',
      background: '#E8EAF6',
    },
  },
  tableMenuRowIcon: {
    fontSize: '17px',
    marginRight: '5px',
  },
  hideColumnRow: {
    display: 'flex',
    color: '#4E4C4C',
    fontSize: '12px',
    padding: '5px 10px',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    '&:hover': {
      background: '#E8EAF6',
      cursor: 'pointer',
    },
  },
  hideColumnMenuRstContainer: {
    overflow: 'auto',
    maxHeight: '400px',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
      background: 'F8FAFD',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '3px',
      background: '#F8FAFD',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#BDC7E2',
      borderRadius: '10px',
    },
  },
  hideColumnMenuBtns: {
    display: 'flex',
    padding: '10px 10px 6px 10px',
    justifyContent: 'center',
  },
  hideColumnMenuBtn: {
    textWrapMode: 'nowrap',
    background: '#E8EAF6',
    borderRadius: '10px',
    minWidth: '90px',
    padding: '3px 16px',
    border: '1px solid #E6E5F1',
    '&:hover': {
      background: '#fff'
    },
  },
  tableHeadingBtn: {
    color: '#3B3545',
    minHeight: '30px',
    height: 'fit-content',
    borderRadius: '15px',
    marginRight: '10px',
    textTransform: 'none',
    outline: '1px solid #cbd1e8',
    padding: '4px 15px 4px 10px',
    '&:hover': {
      color: '#3B3545',
      backgroundColor: '#fff',
    },
  },
  tableHeadingBtnMain: {
    backgroundColor: '#fff',
    padding: '3px 15px 3px 5px',
  },
  tableHeadingSettingsBtn: {
    height: '28px',
    width: '28px',
    borderRadius: '20px',
    '&:hover': {
      color: '#3B3545',
      backgroundColor: '#ffff',
      outline: '1px solid #cbd1e8',
    },
  },
  tableHeadingBtnIcon: {
    fontSize: '15px',
    marginRight: '5px',
  },
  tableHeadRstTitle: {
    paddingLeft: '1px',
    width: '100%',
    color: '#58535f',
    fontWeight: '600',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  tableMenuSelectedBtn: {
    background: '#ffff',//'#EEECF8',D9D8ED
    '&:hover': {
      //backgroundColor: '#E6E5F1',
      outline: '1px solid #D9D8ED',
    },
  },
  tableHeadCell: {
    top: 0,
    position: 'sticky',
    verticalAlign: 'top',
    fontWeight: '500',
    position: 'relative',
    whiteSpace: 'nowrap',
    padding: '3px',
    //borderTop: '1px solid white !important',
    color: 'rgb(35, 33, 33)',
    boxShadow: '0 -1px 0 0 #ffffff, 0 1px 0 0 #ccc',
    '&:hover': {
      '& .rst-search-icon': {
        display: 'flex',
      },
    },
    '&:last-child': {
      borderRight: '1px solid transparent !important',
    },
    '&:first-child': {
      borderLeft: '1px solid transparent !important',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: '-2px',
      width: '2px',
      borderLeft: '1px dashed rgba(143, 143, 143, 0.31)',
      pointerEvents: 'none',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      width: '2px',
      borderRight: '1px dashed rgba(143, 143, 143, 0.31)',
      pointerEvents: 'none',
    },
  },
  embeddedHeadCell: {
    verticalAlign: 'middle',
  },
  tableHeaderDropDownIcon: {
    zIndex: 110,
    marginRight: '2px',
    marginTop: '1px',
    display: 'flex',
    fontSize: '20px',
    backgroundColor: 'rgb(255 255 255 / 50%)',
    cursor: 'pointer',
  },
  tableHeadCellContent: {
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 0,
    justifyContent: 'space-between',
  },
  rstStatusIcons: {
    right: '20px',
    bottom: '3px',
    display: 'flex',
    position: 'absolute',
  },
  rstStatusIcon: {
    right: '1px',
    color: '#4c4c4c',
    fontSize: '16px',
    backgroundColor: '#fff',
    '&:hover': {
      color: '#4c4c4c',
      cursor: 'pointer',
    },
  },
  rstSortAndFilters: {
    top: '1px',
    right: '0px',
    cursor: 'pointer',
    position: 'absolute',
  },
  rstIcon: {
    display: 'none',
    fontSize: '14px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  showMoreInCell: {
    top: '0px',
    opacity: 0.7,
    padding: '2px',
    color: '#222029',
    fontSize: '11px',
    backgroundColor: '#fff',
    '&:hover': {
      opacity: 1,
    },
  },
  rstSearchFilter: {
    marginTop: '5px',
    overflow: 'hidden',
    fontWeight: 'bold',
  },
  newNodeFadeOut: {
    transition: '0.1s',
    background: '#fcefef !important',
  },
  checkboxBoolean: {
    padding: 0,
    marginBottom: '-1px',
    '& .MuiSvgIcon-root': {
      fontSize: '14px',
      color: '#4c4c4c',
    },
  },
  checkboxBooleanEditable: {
    padding: 0,
    '& .MuiSvgIcon-root': {
      fontSize: '19px',
      color: '#4c4c4c',
    },
  },
  tableRowCheckbox: {
    justifyContent: 'center',
    display: 'none',
    '& .MuiSvgIcon-root': {
      width: '17px',
      height: '17px',
      color: '#5D5F77',
    },
    '& .Mui-checked .MuiSvgIcon-root': {
      color: '#222029',
    },
    '& .MuiButtonBase-root': {
      padding: 0,
    },
  },
  gridContainerTrpl: {
    padding: '4px',
    border: '1px solid #a285c5',
  },
  gridRightCol: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  tableTitle: {
    color: '#3B3545',
    marginRight: '30px',
    whiteSpace: 'nowrap',
    marginLeft: '23px',
  },
  showByContainer: {
    width: '100px',
    display: 'flex',
    color: '#878787',
    marginRight: '40px',
    alignItems: 'center',
    '&:hover': {
      color: '#4E4C4C',
    },
  },
  showBySelect: {
    color: '#878787',
    '&:hover': {
      color: '#4E4C4C',
    },
  },
  showBySelectActive: {
    color: '#4E4C4C',
  },
  showByContainerActive: {
    color: '#4E4C4C',
    background: '#cdd6ee8a',
    borderRadius: '5px',
    paddingLeft: '10px',
  },
  showBySelectText: {
    marginRight: '5px',
    whiteSpace: 'nowrap',
  },
  showBySelectContainer: {
    fontSize: '12px',
    background: 'transparent',
  },
  tableTotalContainer: {
    padding: '1px',
    background: '#cdd6ee8a',
    //borderRight: '1px solid #ffffff',
  },
  embedTableTotalContainer: {
    padding: '1px',
    verticalAlign: 'top',
  },
  tableTotal: {
    display: 'flex',
    color: '#4E4C4C',
    fontSize: '12px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    marginTop: '2px',
  },
  tableCell: {
    lineHeight: 'normal',
    padding: '1px',
    height: 'auto',
    boxSizing: 'border-box',
    WebkitFontSmoothing: 'subpixel-antialiased',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeLegibility',
    //borderBottom: '1px solid transparent',
    //borderTop: '1px solid transparent',
    '&:hover': {
      backgroundColor: 'rgb(255 255 255 / 0%) !important',
    }
  },
  tableCellBold: {
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: 'rgb(255 255 255 / 90%)',
    padding: '10px 2px !important',
    verticalAlign: 'middle !important',
    '&:hover': {
      backgroundColor: 'rgb(255 255 255 / 0%) !important',
    }
  },
  tableCellRegular: {
    fontSize: 12,
    fontWeight: 500,
    padding: '2px',
    backgroundColor: 'rgb(255 255 255 / 90%)',
    textRendering: 'optimizeLegibility',
    verticalAlign: 'middle !important',
  },
  resizeHandle: {
    zIndex: 200,
    position: 'absolute',
    display: 'flex',
    top: '0px',
    right: '-1px',
    width: '8px',
    height: '100%',
    padding: '0 0 0 3px',
    cursor: 'ew-resize',
    //borderRight: '1px solid #ffffff',
    '&:hover .resizerLine': {
      background: '#347CFF',
    },
  },
  resizerLine: {
    backgroundColor: '#fff',
    position: 'absolute',
    display: 'block',
    top: '0px',
    bottom: '0px',
    width: '2px',
    borderRadius: '2px',
    height: '100%',
    left: '8px',
  },
  nodeCell: {
    zIndex: 200,
    color: '#4c4c4c'
  },
  indexCellSticky: {
    zIndex: 205,
    left: 0,
    //top: 0,
    position: 'sticky',
    textAlign: 'center',
    minHeight: '25px',
    willChange: 'transform', /* hint for performance */
    boxShadow: '0 -1px 0 0 #ffffff, 0 1px 0 0 #ccc',
    WebkitFontSmoothing: 'subpixel-antialiased',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeLegibility',
    backfaceVisibility: 'hidden',
  },
  indexCellStickyTopWithMark: {
    left: '16px !important',
  },
  indexCellStickyWithMark: {
    zIndex: 205,
    left: '16px',
    position: 'sticky',
    textAlign: 'center',
    backdropFilter: 'blur(3px)',
    WebkitFontSmoothing: 'subpixel-antialiased',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeLegibility',
    backfaceVisibility: 'hidden',
  },
  nodeCellStickyTop: {
    top: 0,
    zIndex: 210,
    padding: '1px 8px',
    position: 'sticky',
    background: '#ffff',
    WebkitFontSmoothing: 'subpixel-antialiased',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeLegibility',
    backfaceVisibility: 'hidden',
  },
  indexCellStickyTop: {
    top: 0,
    left: 0,
    zIndex: 211,
    padding: '1px',
    textAlign: 'center',
    borderRight: 'none',
    position: 'sticky',
    background: '#ffff',
    WebkitFontSmoothing: 'subpixel-antialiased',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeLegibility',
    backfaceVisibility: 'hidden',
    '&:hover': {
      '& .row-checkbox': {
        display: 'flex',
      },
      '& .row-index-text': {
        display: 'none',
      },
    },
  },
  tableCellLeft: {
    padding: '2px',
    fontSize: 12,
    minHeight: '25px',
    verticalAlign: 'middle',
    backgroundColor: 'rgba(255, 255, 255, 20%)',
    WebkitFontSmoothing: 'subpixel-antialiased',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeLegibility',
    backfaceVisibility: 'hidden',
    '&:hover': {
      '& .row-checkbox': {
        display: 'flex',
      },
      '& .row-index-text': {
        display: 'none',
      },
    },
  },
  gradientOverlay: {
    position: 'absolute',
    zIndex: -2,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: `linear-gradient(to top, rgb(192 217 197), rgb(212 204 249 / 45%))`,
    pointerEvents: 'none',
  },
  blurBGForCells: {
    zIndex: 1,
    backdropFilter: 'blur(3px)',
    '-webkit-backdrop-filter': 'blur(3px)',
    position: 'absolute',
    top: '1px',
    left: '-1px',
    width: '100%',
    height: 'calc(100% - 4px)',
    willChange: 'transform',
  },
  ontologyMarkCellRow: {
    left: -1,
    zIndex: 205,
    position: "sticky",
    transition: '0.1s',
    verticalAlign: 'middle',
    border: '1px solid #fff',
    backgroundColor: '#fff',
    WebkitFontSmoothing: 'subpixel-antialiased',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeLegibility',
    backfaceVisibility: 'hidden',
  },
  tableRow: {
    //willChange: 'transform',
    background: 'transparent',
  },
  trpsTableRow: {
    height: 'auto',
    borderTop: '1px solid rgba(255, 255, 255, 0)',
    minHeight: '25px',
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
  },
  trpsTableRowBold: {
    borderTop: '1px solid rgba(255, 255, 255, 0)',
    borderBottom: '5px solid rgba(255, 255, 255, 0)',
  },
  tableRowSelected: {
    backgroundColor: 'rgba(255, 255, 255, 0)',
    transition: 'background-color 0s ease-out !important',
  },
  tableCellSelected: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    transition: 'background-color 0s ease-out !important',
  },
  tableCellLeftNodeImg: {
    width: '23px',
    height: '23px',
    flexShrink: '0',
    marginRight: '10px',
    borderRadius: '100%',
  },
  tableCellLeftNodeLink: {
    fontSize: '12px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  tableCellHover: {
    position: 'relative',
    '&:hover': {
      background: 'transparent',
      '& .trpl-add-icon': {
        display: 'flex',
      },
    },
  },
  hiden: {
    display: 'none',
  },
  trplContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  trplTableNodes: {
    width: '100%',
    overflow: 'hidden',
    cursor: 'pointer',
    marginTop: '1px',
    '&:first-child': {
      marginTop: '0px !important',
    },
  },
  trplValue: {
    height: '21px',
    display: 'flex',
    fontSize: '12px',
    maxHeight: '21px',
    fontWeight: '400px',
    borderRadius: '0',
    overflow: 'hidden',
    //fontFamily: '"Urbanist", sans-serif !important',
    boxSizing: 'border-box',
    textOverflow: 'ellipsis',
    padding: '1px',
    //margin: '0px 2px 0px 2px',
    '&:hover': {
      background: '#D3FA5F',
    },
  },
  addTrplIcon: {
    display: 'none',
    marginLeft: '2px',
    fontSize: '17px',
    color: '#222029',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  trplFormIcon: {
    marginLeft: 0,
  },
  loadMoreContainer: {
    margin: '10px',
    display: 'flex',
    justifyContent: 'center',
  },
  loaderContainer: {
    display: 'flex',
    padding: '10px',
    backgroundColor: '#fff',
    justifyContent: 'center',
  },
  doActionBtn: {
    minWidth: '1px',
    fontSize: '13px',
    padding: '2px 4px',
    borderRadius: '2px',
    whiteSpace: 'nowrap',
    background: '#dbdbdb',
    '&:hover': {
      background: '#3f51b5',
      color: '#fff',
    },
  },
  tableLoaderOverlay: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '250',
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255,255,255,0.8)',
  },
  tableStickyHeadRow: {
    //top: 0,
    zIndex: 209,
    //position: 'sticky',
    border: 'none',
    height: '25px',
    minHeight: '25px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.02)',
    lineHeight: 'normal',
    boxSizing: 'border-box',
    backfaceVisibility: 'hidden',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeLegibility',
    WebkitFontSmoothing: 'subpixel-antialiased',
  },
  stickyCell: {
    top: 0,
    zIndex: 209,
    zIndex: 2,
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    position: 'sticky',
    boxSizing: 'border-box',
    backgroundColor: '#ffff',
    //borderTop: '1px solid white',
    WebkitFontSmoothing: 'subpixel-antialiased',
    MozOsxFontSmoothing: 'auto',
    textRendering: 'optimizeLegibility',
    backfaceVisibility: 'hidden',
  },
  mandatoryCellIcon: {
    display: 'none',
    color: '#DD5900',
    fontSize: '17px',
    '&:hover': {
      color: 'red',
      cursor: 'pointer',
    },
  },
  '@media (max-width: 1200px)': {
    tableHeadingBtn: {
      minWidth: '30px',
      width: '30px',
      padding: '4px',
    },
    tableHeadingBtnText: {
      display: 'none',
    },
    tableHeadingBtnIcon: {
      margin: 0,
    },
  },
  actionsStatus: {
    left: '30px',
    bottom: '30px',
    zIndex: '999',
    position: 'fixed',
    borderRadius: '4px',
    padding: '10px 13px',
    background: '#4E4C4C',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
  },
  actionsStatusText: {
    color: '#fff',
    fontSize: '12px',
    marginRight: '40px',
  },
  actionsStatusCancel: {
    color: '#608EF8',
    fontSize: '12px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  emptyTableText: {
    color: '#4c4c4c',
    display: 'flex',
    margin: '10px',
    justifyContent: 'center',
  },
  highlightVertical: {
    // borderLeft: '1px solid rgb(0, 0, 0)',
    // borderRight: '1px solid rgb(0, 0, 0)',
  },
  highlightHorisontalRow: {
    //backgroundColor: 'rgba(255, 255, 255, 0.4)',//'transparent !important',
    //boxShadow: 'inset 0 0.5px 0 rgba(0, 0, 0, 0.9), inset 0 -0.5px 0 rgba(0, 0, 0, 0.9)',
    //outline: '1px solid rgb(0, 0, 0)',
    borderTop: '1px solid rgb(0, 0, 0)',
    borderBottom: '1px solid rgb(0, 0, 0)',
  },
  highlightedRowCell: {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
  },
  highlightHorisontalRowBold: {
    //backgroundColor: 'transparent !important',
    boxShadow: 'inset 0 0.5px 0 rgb(16, 20, 67), inset 0 -0.5px 0 rgb(16, 20, 67)',
  },
  highlightVerticalBold: {
    // borderLeft: '1px solid rgb(0, 0, 0)',
    // borderRight: '1px solid rgb(0, 0, 0)',
  },
  // highlightHorisontalBold: {
  //   backgroundColor: 'transparent !important',
  //   boxShadow: 'inset 0 0.5px 0 #1976d2, inset 0 -0.5px 0 #1976d2',
  //   // borderTop: '1px solid rgb(0, 0, 0)',
  //   // borderBottom: '1px solid rgb(0, 0, 0)',
  // },
  highlightHead: {
    '&::before': {
      content: '""',
      zIndex: 1,
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: '-2px',
      width: '2px',
      borderLeft: '1.5px dashed #1976d2 !important',
      pointerEvents: 'none',
    },
    '&::after': {
      content: '""',
      zIndex: 1,
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      width: '2px',
      borderRight: '1.5px dashed #1976d2 !important',
      pointerEvents: 'none',
    },
  }
};
